import React from "react";
import BasicCalculator from "./BasicCalculator";

const Calculator = () => {
  return (
    <div className="calculator-container">
      <div className="calculator-main">
        <BasicCalculator />
      </div>
    </div>
  );
};

export default Calculator;
